import { render } from "./index.vue?vue&type=template&id=91c9774e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Modal/TrfModalExcluirTarefa/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "91c9774e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('91c9774e', __exports__)) {
    console.log('reload')
    api.reload('91c9774e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=91c9774e", () => {
    console.log('re-render')
    api.rerender('91c9774e', render)
  })

}


export default __exports__